export function home(spaceId) {
  return {
    path: ['spaces', 'detail', 'home'],
    params: { spaceId },
    options: { reload: true }
  };
}

export function usage(spaceId) {
  return {
    path: ['spaces', 'detail', 'settings', 'usage'],
    params: { spaceId },
    options: { reload: true }
  };
}



// WEBPACK FOOTER //
// ./src/javascripts/ui/NavStates/Space.es6.js